import { render, staticRenderFns } from "./AdminInterstateTableList.vue?vue&type=template&id=6bb441d6&scoped=true"
import script from "./AdminInterstateTableList.vue?vue&type=script&lang=js"
export * from "./AdminInterstateTableList.vue?vue&type=script&lang=js"
import style0 from "./AdminInterstateTableList.vue?vue&type=style&index=0&id=6bb441d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb441d6",
  null
  
)

export default component.exports